import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';

var _excluded = ["as", "align", "className", "direction", "justify", "noWrap", "spacing"],
  _excluded2 = ["as", "className", "lg", "md", "sm", "xl", "xs"];
var GridContainer = /*#__PURE__*/React.forwardRef(function GridContainer(_ref, ref) {
  var _classnames;
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'div' : _ref$as,
    align = _ref.align,
    className = _ref.className,
    direction = _ref.direction,
    justify = _ref.justify,
    _ref$noWrap = _ref.noWrap,
    noWrap = _ref$noWrap === void 0 ? false : _ref$noWrap,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 'normal' : _ref$spacing,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-GridContainer', (_classnames = {}, _defineProperty(_classnames, "--align-".concat(align), align), _defineProperty(_classnames, "--direction-".concat(direction), direction), _defineProperty(_classnames, "--justify-".concat(justify), justify), _defineProperty(_classnames, '--no-wrap', noWrap), _defineProperty(_classnames, "--spacing-".concat(spacing), spacing), _classnames), className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps, {
    ref: ref
  }));
});
GridContainer.displayName = 'Grid.Container';
var GridItem = /*#__PURE__*/React.forwardRef(function GridItem(_ref2, ref) {
  var _classnames2;
  var _ref2$as = _ref2.as,
    As = _ref2$as === void 0 ? 'div' : _ref2$as,
    className = _ref2.className,
    lg = _ref2.lg,
    md = _ref2.md,
    sm = _ref2.sm,
    xl = _ref2.xl,
    xs = _ref2.xs,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var finalClasses = classnames('C-GridItem', (_classnames2 = {
    '--lg-size-auto': lg === true
  }, _defineProperty(_classnames2, "--lg-size-".concat(lg), lg && lg !== true), _defineProperty(_classnames2, '--md-size-auto', md === true), _defineProperty(_classnames2, "--md-size-".concat(md), md && md !== true), _defineProperty(_classnames2, '--sm-size-auto', sm === true), _defineProperty(_classnames2, "--sm-size-".concat(sm), sm && sm !== true), _defineProperty(_classnames2, '--xl-size-auto', xl === true), _defineProperty(_classnames2, "--xl-size-".concat(xl), xl && xl !== true), _defineProperty(_classnames2, '--xs-size-auto', xs === true), _defineProperty(_classnames2, "--xs-size-".concat(xs), xs && xs !== true), _classnames2), className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps, {
    ref: ref
  }));
});
GridItem.displayName = 'Grid.Item';
var Grid = {
  Container: GridContainer,
  Item: GridItem
};

export { GridContainer, GridItem, Grid as default };
